export const Warning = `<svg viewBox="0 0 28 28" width="28" height="28">
  <circle cx="14" cy="14" r="13.5" stroke="#CC7A00" fill="none"/>
  <path d="M12.5 19.13c0-.41.15-.76.44-1.04.3-.28.65-.42 1.06-.42s.8.14 1.08.42c.28.28.42.63.42 1.04s-.14.77-.42 1.05c-.28.27-.64.41-1.08.41s-.77-.14-1.06-.41c-.3-.28-.44-.63-.44-1.05zM12.62 12.63V8h2.79v4.63l-.6 4.04h-1.59l-.6-4.04z" fill="#CC7A00"/>
</svg>`;
